import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { SoloService } from '@finder/shared/services/solo-service/solo.service';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';
import { ConfigService } from '@finder/core/config.service';
import * as i0 from "@angular/core";
import * as i1 from "../../services/solo-service/solo.service";
import * as i2 from "../../services/window-ref/window-ref.service";
import * as i3 from "../../../core/config.service";
export class MyIdGuard {
    constructor(soloService, windowRef, config) {
        this.soloService = soloService;
        this.windowRef = windowRef;
        this.config = config;
    }
    canActivate() {
        // Check the env var to see if gating is disabled
        if (this.config.getValue('disableMyIDGating') === true) {
            return of(true);
        }
        // Call the API for gating check
        return this.soloService.validateToken()
            .pipe(map(token => token.valid), catchError(error => {
            if (error && error.status === 401) {
                // Redirect to myid login
                this.windowRef.nativeWindow.location.href =
                    this.soloService.getLoginRedirectUrl(this.windowRef.nativeWindow.location.href);
            }
            return of(false);
        }));
    }
}
MyIdGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MyIdGuard_Factory() { return new MyIdGuard(i0.ɵɵinject(i1.SoloService), i0.ɵɵinject(i2.WindowRef), i0.ɵɵinject(i3.ConfigService)); }, token: MyIdGuard, providedIn: "root" });
